import React, { FC } from 'react';
import { generatePath, Navigate, RouteObject, useParams } from 'react-router-dom';
import { CspPath } from '../../../CspPath';
import { PathUtil } from '../util/PathUtil';

const TeamMemberDefaultRoute: FC = () => {
  const { userId } = useParams<{ userId: string }>();
  if (!userId) {
    return <Navigate to={CspPath.TEAM_MEMBER_LIST} replace />;
  }

  return <Navigate to={generatePath(CspPath.TEAM_MEMBER_OVERVIEW, { userId })} replace />;
};

const TeamMemberRoot = React.lazy(() => import('../../team-member/team-member-overview/page/TeamMemberRoot'));
const TeamMemberOverviewPage = React.lazy(
  () => import('../../team-member/team-member-overview/page/TeamMemberOverviewPage'),
);

export const TeamMemberRoutes: RouteObject[] = [
  {
    element: <TeamMemberRoot />,
    children: [
      {
        path: PathUtil.toRelativePath(CspPath.TEAM_MEMBER_NAV, CspPath.TEAM_MEMBER_OVERVIEW, true),
        element: <TeamMemberOverviewPage />,
      },
      {
        path: '*',
        element: <TeamMemberDefaultRoute />,
      },
    ],
  },
];
